<p>version-history-settings works!</p>
